import {
  ColorKey,
  relevanceJudgementsMapping,
} from '../../../models/relevance';

import { Tooltip } from '@mui/material';
import styled from 'styled-components';

interface RelevanceIconProps {
  relevanceJudgement?: number;
  relevanceScore?: number;
  hideDescription?: boolean;
  className?: 'criteria-icon';
}

export function RelevanceIcon(props: RelevanceIconProps): JSX.Element {
  const { relevanceJudgement, relevanceScore, hideDescription, className } =
    props;
  if (relevanceJudgement && relevanceJudgement > 0) {
    const mappedRelevance = relevanceJudgementsMapping.find(
      (i) => i.relevance === relevanceJudgement,
    );
    if (mappedRelevance) {
      const title = `${mappedRelevance.description}${
        relevanceScore ? ` (${relevanceScore.toFixed(2)})` : ''
      }`;
      return hideDescription ? (
        <StyledIconWrapper
          colorkey={mappedRelevance.colorKey}
          className={className}
        >
          <mappedRelevance.IconComponent />
        </StyledIconWrapper>
      ) : (
        <Tooltip title={title} placement="top">
          <Wrapper>
            <StyledIconWrapper colorkey={mappedRelevance.colorKey}>
              <mappedRelevance.IconComponent />
            </StyledIconWrapper>
            <StyledDescription colorkey={mappedRelevance.colorKey}>
              {`${mappedRelevance.description}:`}
            </StyledDescription>
          </Wrapper>
        </Tooltip>
      );
    }
  }
  return <></>;
}

const StyledIconWrapper = styled.span<{ colorkey: ColorKey }>`
  margin-right: 5px;
  color: ${({ colorkey, theme }) => `${theme.other.relevance[colorkey]}`};

  & .MuiSvgIcon-root {
    font-size: 20px;
    vertical-align: bottom;
  }
  &.criteria-icon .MuiSvgIcon-root {
    font-size: 16px;
  }
`;

const Wrapper = styled.span`
  margin-right: 5px;
  user-select: none;
`;

const StyledDescription = styled.span<{ colorkey: ColorKey }>`
  color: ${({ colorkey, theme }) => `${theme.other.relevance[colorkey]}`};
`;
